module.exports = __webpack_public_path__ + "static/media/10_1.e8220148.png";